<!--
 * @Author: shaozongyao
 * @Date: 2021-11-30 13:40:40
 * @LastEditTime: 2021-12-08 14:29:21
 * @LastEditors: your name
-->
<template>
  <div class="container">
    <div class="bg-white padding-14">
      <div
        class="flex align-center padding-tb-6 padding-lr-8"
        style="background-color: #D7EAFF; color: #1F81F4; border-radius: 16px;"
      >
        <img :src="$oss(34)" style="width: 25px; height: 25px;" alt="" />
        <span class="margin-left-4">已累计为您保障{{ count }}次出行</span>
      </div>

      <div v-if="info.insureNo" class="margin-top-20">
        <div class="txt-16 text-bold">投保订单</div>
        <div class="margin-top-10 flex align-center text-grey1 text-12">
          <div>{{ info.getOnTime }} 出发</div>
          <!-- <div class="flex align-center margin-left-10">
            <div>{{ info.approvedPassengerCapacity }}人</div>
            <div class="ball"></div>
            <div>拼座</div>
          </div> -->
        </div>
        <div class="margin-top-6">
          <div class="flex align-center">
            <div class="address-ball bg-primary"></div>
            <div class="margin-left-8 text-bold">{{ info.startAddress }}</div>
          </div>
          <div class="flex align-center margin-top-4">
            <div class="address-ball bg-blue"></div>
            <div class="margin-left-8 text-bold">{{ info.endAddress }}</div>
          </div>
        </div>

        <div class="margin-top-8 bg-body padding-14" style="border-radius: 6px;">
          <div class="flex align-center">
            <div>保单号：</div>
            <div class="text-grey">{{ info.insureNo }}</div>
          </div>
          <div class="flex align-center margin-top-6">
            <div>投保人：</div>
            <div class="text-grey">{{ info.policyHolder }}</div>
          </div>
          <div class="flex align-center margin-top-6">
            <div>承保人：</div>
            <div class="text-grey">{{ info.insurer }}</div>
          </div>
          <div class="flex margin-top-6">
            <div>被保人：</div>
            <div class="text-grey flex-1">{{ info.insuredPerson }}</div>
          </div>
          <div class="flex align-center margin-top-6">
            <div>车牌号：</div>
            <div class="text-grey">{{ info.plateNumber }}</div>
          </div>
          <div class="flex align-center margin-top-6">
            <div>查看</div>
            <div class="text-primary" @click="$router.push('/insurance/detail')">《保险详情》</div>
          </div>
        </div>
      </div>

      <div v-else class="margin-top-20">
        <van-empty description="该行程暂未投保" />
      </div>
    </div>

    <div class="bg-white padding-14 margin-top-10">
      <div>
        <div class="text-16 text-bold">保障时效</div>
        <div class="margin-top-8">
          乘客、车主在使用滇约易游顺风车出行期间，平台将为乘客及车主免费投保。
        </div>
        <img :src="$oss(44)" style="width: 100%;" alt="">

        <div class="margin-top-16">
          <div class="text-16 text-bold">理赔流程</div>
          <div class="margin-top-8">
            乘客、车主如在滇约易游顺风车出行期间发生任何保险事故，建议及时报警处理，待人身安全后，及时联系保险公司进行报案理赔。
            <p>紫金财产保险股份有限公司电话：95312</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from 'api/user'
import Vue from 'vue'
import { Empty } from 'vant'
import {
  queryInsure
} from 'api/insurance'

Vue.use(Empty)
export default {
  data () {
    return {
      count: 0,
      info: {}
    }
  },
  created () {
    this.getUserInfo()
    this.queryInsure()
  },
  methods: {
    async getUserInfo () {
      const res = await getUserInfo()
      this.count = res.customer.orders
    },
    async queryInsure () {
      const res = await queryInsure(this.$route.params.id)
      res.getOnTime = this.$moment(res.getOnTime).format('YYYY-MM-DD HH:mm')
      this.info = res || {}
    }
  }
}
</script>

<style lang="scss" scoped>
.ball {
  width: 3px;
  height: 3px;
  background-color: $grey1;
  border-radius: 50%;
  margin: 0 4px;
}

.address-ball {
  width: 5px;
  height: 5px;
  border-radius: 50%;
}
</style>
